import React, { useState, ChangeEvent, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import {
  exportJsonToExcel,
  readExcelFile,
  workbookToJsonArray,
} from "../../../../../AdminApi/commFunc";
import FileUploadBtn from "../../../../Button/FileUploadBtn";
import LineBtn from "../../../../Button/LineBtn";
import Flex from "../../../../DefaultStyles/Flex";
import AlertModal from "../../../../Modal/AlertModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface MassiveRegisterProps {
  isPoint?: boolean;
  massiveData: any[] | null;
  setMassiveData: Dispatch<SetStateAction<any[] | null>>;
}

interface SFileName {
  fileName?: string;
}

const massivePointForm = [
  {
    A: "uid",
    B: "type",
    C: "value",
    D: "lppr_dl",
  },
];

const massiveCouponForm = [
  {
    A: "uid",
    B: "id",
  },
];

export default function MassiveRegister({
  isPoint,
  massiveData,
  setMassiveData,
}: MassiveRegisterProps) {
  const [fileName, setFileName] = useState<undefined | string>(undefined);
  const [uploadFailModal, setUploadFailModal] = useState(false);

  const uploadExcel = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.item(0)) {
      const file = e.target.files[0];

      setFileName(file.name ?? "");

      readExcelFile(
        file,
        (workBook) => {
          console.log(workBook);

          if (workBook) {
            const json = workbookToJsonArray(workBook) as any[];

            setMassiveData(json);
          }
        },
        () => setUploadFailModal(true)
      );
    }
  };

  return (
    <>
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>파일 업로드</ModalLabel>

        <div style={{ width: "100%" }}>
          <Flex gapSize={10}>
            <FileUploadBtn
              btnText="파일 선택"
              btnColor="mint"
              btnHeight={38}
              onChangeEvent={uploadExcel}
              isDisabled={fileName ? true : false}
            />

            <LineBtn
              icon="file_download"
              btnText="양식 다운로드"
              btnHeight={38}
              btnClickEvent={() => {
                exportJsonToExcel(
                  isPoint ? massivePointForm : massiveCouponForm,
                  "",
                  `일괄 지급_링키드 ${
                    isPoint ? "포인트" : "쿠폰"
                  } 양식_v1.0.xlsx`,
                  true
                );
              }}
            />
          </Flex>

          {fileName && (
            <Flex style={{ marginTop: 10 }} gapSize={10}>
              <FileNameBox fileName={fileName}>{fileName}</FileNameBox>

              <LineBtn
                btnText="삭제"
                btnHeight={38}
                btnClickEvent={() => {
                  setMassiveData(null);
                  setFileName(undefined);
                }}
              />
            </Flex>
          )}
        </div>
      </ModalRow>

      {massiveData && (
        <ModalRow>
          <ModalLabel>대상 인원</ModalLabel>

          <FileNameBox>{massiveData?.length ?? 0}명</FileNameBox>
        </ModalRow>
      )}

      {uploadFailModal && (
        <AlertModal
          title={`파일 업로드에 실패했어요.
        다시 시도해 보세요.`}
          customCancelBtn={<></>}
          confirmEvent={() => {
            setUploadFailModal(false);
          }}
        />
      )}
    </>
  );
}

export const FileNameBox = styled.div<SFileName>`
  display: flex;
  align-items: center;

  width: 100%;
  border-radius: 3px;
  background-color: #f6f6f8;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #aaaaaa;
  padding: 9px 14px;
`;
